import type { Confidence } from "@/types";

export function money(n: number, currency = "CNY"): string {
  const sym = currency === "CNY" ? "¥" : currency === "USD" ? "$" : currency === "EUR" ? "€" : "";
  return `${sym}${n.toLocaleString("en-US", { maximumFractionDigits: 2 })}${sym ? "" : " " + currency}`;
}

export function weight(grams: number): string {
  if (grams >= 1000) return `${(grams / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 })} kg`;
  return `${Math.round(grams)} g`;
}

export function eta(min: number | null, max: number | null): string {
  if (min === null && max === null) return "—";
  if (min !== null && max !== null) return min === max ? `${min} d` : `${min}–${max} d`;
  return `${min ?? max} d`;
}

export const confLabel: Record<Confidence, string> = {
  high: "High",
  medium: "Medium",
  low: "Low",
  unknown: "Unknown",
};

export function scoreColor(score: number | null): string {
  if (score === null) return "var(--text-faint)";
  if (score >= 75) return "var(--good)";
  if (score >= 55) return "var(--accent)";
  if (score >= 40) return "var(--warn)";
  return "var(--bad)";
}

export function pct(n: number): string {
  return `${Math.round(n * 100)}%`;
}
